<template>
  <div class="documents">
    <BasicAlert
      v-if="alertMessageBilan"
      alertLabel="Le document Bilan de positionnement est obligatoire si validation CQP et TFP de branche."
    />

    <div
      class="col-36"
      v-if="meta.attestationPiecesJustificatives?.$status === PropertyStatus.Required"
    >
      <WrapperCheckbox
        id="field_attestationPiecesJustificatives"
        v-model="attestationPiecesJustificativesModel"
        :alertLabel="meta.attestationPiecesJustificatives?.$messageErreurDirty!"
        label="L'employeur atteste disposer de l'ensemble des pièces justificatives nécessaires au dépôt du dossier"
        :readonly
        class="wrapper-width-fit wrapper-without-margin-top"
      />
    </div>
    <UploadFichiers />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { UploadFichiers } from '@/features/interface/demande/shared/components'
  import { useDemandeAFStore } from '../../useDemandeAFStore'

  defineProps({
    alertData: Object,
  })

  const store = useDemandeAFStore()
  const { setupFieldWithKey } = useDemandeAFStore()

  const { meta, readonly, model } = storeToRefs(store)

  const attestationPiecesJustificativesModel = setupFieldWithKey<boolean>('attestationPiecesJustificatives', true)

  const alertMessageBilan = computed(() => {
    return model?.value?.employeur?.etablissement?.idcc?.code === '3043' &&
      (model?.value?.sousDispositif === 'PDC' || model?.value?.sousDispositif === 'ActionStandard')
      ? true
      : false
  })
</script>

<style scoped lang="less">
  .documents {
    display: flex;
    flex-direction: column;
    gap: @spacing-25;

    &__section {
      display: flex;
      flex-direction: column;
      gap: @spacing-15;

      &__button {
        width: 500px;
      }
    }
  }
</style>
